module.exports = __webpack_public_path__ + "media/images/partial_space-c69145ffc3b2b35a48d783849509d291.svg";